var map = {
	"./adult/nn/2 1 ordkjedetekst.mp3": 572,
	"./adult/no/2 1 ordkjedetekst.mp3": 573,
	"./youth/de/2 1 ordkjedetekst.mp3": 574,
	"./youth/nn/2 1 ordkjedetekst.mp3": 575,
	"./youth/no/2 1 ordkjedetekst.mp3": 576,
	"./youth/se/2 1 ordkjedetekst.mp3": 577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 571;